// VerifyEmailPage.jsx

import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { verifyEmail } from "../api/reportApi";

/*
 * Prevent duplicate verification requests for the same token.
 *
 * This map lives at module level, so it survives React component
 * remounts (including React StrictMode's development remount).
 */
const verificationRequests = new Map();

function verifyEmailOnce(token) {
    if (verificationRequests.has(token)) {
        return verificationRequests.get(token);
    }

    const request = verifyEmail(token);

    verificationRequests.set(token, request);

    return request;
}

export default function VerifyEmailPage() {
    const [searchParams] = useSearchParams();

    const token = searchParams.get("token");

    const [status, setStatus] = useState("loading");
    const [message, setMessage] = useState("");

    useEffect(() => {
        if (!token) {
            setStatus("error");
            setMessage("Verification token is missing.");
            return;
        }

        let mounted = true;

        verifyEmailOnce(token)
            .then((response) => {
                if (!mounted) {
                    return;
                }

                setStatus("success");
                setMessage(
                    response ||
                    "Email verified successfully. You can now log in."
                );
            })
            .catch((err) => {
                if (!mounted) {
                    return;
                }

                setStatus("error");
                setMessage(
                    err.message ||
                    "Email verification failed."
                );
            });

        return () => {
            mounted = false;
        };
    }, [token]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-black text-white px-4">
            <div className="w-full max-w-md rounded-2xl border border-gray-700 bg-neutral-950 p-6 shadow-xl text-center">

                {status === "loading" && (
                    <>
                        <h1 className="text-2xl font-semibold mb-4">
                            Verifying your email...
                        </h1>

                        <p className="text-gray-400">
                            Please wait.
                        </p>
                    </>
                )}

                {status === "success" && (
                    <>
                        <h1 className="text-2xl font-semibold mb-4">
                            Email verified
                        </h1>

                        <p className="text-green-400 mb-6">
                            {message}
                        </p>

                        <Link
                            to="/login"
                            className="block w-full rounded-xl bg-red-500 py-3 font-semibold text-black"
                        >
                            Go to login
                        </Link>
                    </>
                )}

                {status === "error" && (
                    <>
                        <h1 className="text-2xl font-semibold mb-4">
                            Verification failed
                        </h1>

                        <p className="text-red-400 mb-6">
                            {message}
                        </p>

                        <Link
                            to="/login"
                            className="block w-full rounded-xl bg-red-500 py-3 font-semibold text-black"
                        >
                            Go to login
                        </Link>
                    </>
                )}

            </div>
        </div>
    );
}